/* eslint-disable react/no-danger, react/no-unknown-property */
// Product Style List Item
import React from 'react';
import PropTypes from 'prop-types';

const ProductStyleListItem = ({ productstyle }) => (
  <div className="product-link-list-item productstyle-list-item">
    <div className={`product-link-block productstyle-link ${productstyle.className} border-${productstyle.color}`}>
      <a className="full-cover" href={productstyle.pageUrl} aria-label={productstyle.name}><span notranslate className="hidden">{productstyle.name}</span></a>
      <div className="product-link-image-container">
        <img className="product-link-image" src={productstyle.imageUrl} alt={productstyle.name} />
      </div>
      <div className="product-link-content-container">
        <h3 className="heading-sm product-link-heading productstyle-link-heading" isolate><span className="title-link-text" dangerouslySetInnerHTML={{ __html: productstyle.name }} /></h3>
        <ul className="bullet-points">
          {productstyle.bulletPoints.map(item => <li key={`key-${item.split(' ')[0]}`}dangerouslySetInnerHTML={{ __html: item }} />)}
        </ul>
        <div className="pricing">
          <p className="pricing-text">
            {productstyle.isOnPromotion
              ? <span notranslate className="price onsaleprice">{productstyle.startingPrice}</span>
              : <span notranslate className="price">{productstyle.startingPrice}</span>}
            <br />
            <span className="price-caption">for 24&Prime; x 36&Prime;</span>
            <br />
            {productstyle.isOnPromotion
              ? <span className="onsale" isolate>{productstyle.promotionComment}</span>
              : ''}
          </p>
        </div>
      </div>
    </div>
  </div>
);

ProductStyleListItem.propTypes = {
  productstyle: PropTypes.shape({
    name: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    pageUrl: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    bulletPoints: PropTypes.arrayOf(PropTypes.object).isRequired,
    isOnPromotion: PropTypes.bool.isRequired,
    startingPrice: PropTypes.string.isRequired,
    promotionComment: PropTypes.string.isRequired,
  }),
};

export default ProductStyleListItem;
/* eslint-enable react/no-danger, react/no-unknown-property */
